<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler display="md" :mobile="windowHeight < 768 ? true : false" />

      <div class="col-md-3 col-sm-12 col">
        <h3 style="conferencia-titulo cursor: pointer; font-size: 16px" @click="home()">
          Sistema de Participações
        </h3>
      </div>
      <div class="conferencia-perfil col-md-3 col-sm-12 col">
        <span style="color: black"><b>Conferência: </b>{{ conferencia_nome }}</span>
      </div>
      <div class="conferencia-perfil col-md-3 col-sm-12 col">
        <span style="color: black"><b>Perfil: </b>{{ perfil_nome }}</span>
      </div>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <ModalConferenciaPerfil />
  </div>
</template>

<script>
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "@/templates/containers/DefaultAside";
import DefaultHeaderDropdown from "@/templates/containers/DefaultHeaderDropdown";
import DefaultHeaderDropdownAccnt from "@/templates/containers/DefaultHeaderDropdownAccnt";
import DefaultHeaderDropdownMssgs from "@/templates/containers/DefaultHeaderDropdownMssgs";
import DefaultHeaderDropdownTasks from "@/templates/containers/DefaultHeaderDropdownTasks";
import SessionStorage from "@/services/session-storage";
import { mapState } from "vuex";
import ModalConferenciaPerfil from "@/components/shared/ModalConferenciaPerfil";

export default {
  name: "SiteTemplate",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ModalConferenciaPerfil,
  },
  data() {
    return {
      windowHeight: window.innerWidth
    };
  },
  mounted() {
    this.$store.dispatch("getPerfil", SessionStorage.get("perfil_atual_id"));

    let usuario = SessionStorage.get("usuario");
    if (!usuario) {
      this.$router.push("/externa");
    }
  },
  computed: {
    ...mapState({
      usuario: (state) => state.usuario.usuario,
      configurarConferencia: (state) => state.conferencia.configurarConferencia,
    }),
    conferencia_nome() {
      return this.$store.state.usuario.configuracaoAtual.conferencia_atual_nome;
    },
    perfil_nome() {
      return this.$store.state.usuario.configuracaoAtual.perfil_atual_nome;
    },
    perfil() {
      return this.$store.state.perfil.perfil;
    },
    nav() {

      let news = [];

      if (!this.perfil.is_admin_local) {
        let home = {
          name: "Apresentação",
          url: "/conferencia",
          icon: "fa fa-home",
        };
        news.push(home);
      }

      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let transmissaoAtual = {
          name: "Visualizar Transmissão",
          url: "/sala/consulta",
          icon: "fa fa-tv",
        };

        news.push(transmissaoAtual);

        let forum = {
          name: "Fórum",
          url: "/proposta-entrada",
          icon: "fa fa-comments",
        };

        news.push(forum);
      }

      // if (
      //   (this.usuario && this.usuario.super_usuario) ||
      //   !this.configurarConferencia ||
      //   !this.configurarConferencia.situacao ||
      //   this.configurarConferencia.situacao !== "Suspensa"
      // ) {
        if (this.perfil.is_admin_conferencia) {
          let configurarConferencia = {
            name: "Configurar Conferência",
            url: "/configurarConferencia/passo1/cadastrar",
            icon: "fa fa-wrench",
          };
          news.push(configurarConferencia);
        }
      // }

      if (this.perfil.is_admin_conferencia) {
        let sala = {
          name: "Gerenciar Salas de Transmissões",
          url: "/sala",
          icon: "fa fa-tv",
        };

        news.push(sala);
      }

      if (this.perfil.is_admin_conferencia) {
        let sala = {
          name: "Gerenciar Administradores",
          url: "/administradores",
          icon: "fa fa-users",
        };

        news.push(sala);
      }

      if (this.perfil.is_admin_conferencia) {
        let participantes = {
          name: "Inscrições",
          url: "/participante",
          icon: "fa fa-users",
        };

        news.push(participantes);
      }
      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let participantes = {
          name: "Inscrições",
          url: "/inscricoes/delegado",
          icon: "fa fa-users",
        };

        news.push(participantes);
      }

      if (this.perfil.is_admin_conferencia) {
        let formularios = {
          name: "Formulários",
          url: "/formularios",
          icon: "fa fa-list",
        };

        news.push(formularios);
      }

      if (this.perfil.is_admin_conferencia) {
        let proposta = {
          name: "Caderno de Propostas",
          url: "/proposta",
          icon: "fa fa-book",
        };

        news.push(proposta);
      }

      if (this.perfil.sigla == "delegado" || this.perfil.is_admin_conferencia) {
        let propor_proposta = {
          name: "Propostas",
          url: "/proposta/lista-propostas",
          icon: "fa fa-book",
        };

        news.push(propor_proposta);
      }

      if (this.perfil.is_admin_local) {
        let proposta_delegacao = {
          name: "Proposta Delegação",
          url: "/propostas/delegacao",
          icon: "fa fa-book",
        };

        news.push(proposta_delegacao);
      }

      if (this.perfil.is_admin_local) {
        let delegacao = {
          name: "Delegação",
          url: "/delegacao",
          icon: "fa fa-users",
        };

        news.push(delegacao);
      }


      if (this.perfil.is_admin_conferencia) {
        let documento = {
          name: "Gerenciar Documentos",
          url: "/arquivos",
          icon: "fa fa-file",
        };

        news.push(documento);
      }

      if (this.perfil.is_admin_conferencia) {
        let link = {
          name: "Gerenciar Links",
          url: "/links",
          icon: "fa fa-link",
        };

        news.push(link);
      }

      if (this.perfil.is_admin_conferencia) {
        let certificado = {
          name: "Gerenciar Certificados",
          url: "/certificados",
          icon: "fa fa-file-o",
        };

        news.push(certificado);
      }
      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let certificado = {
          name: "Emitir Certificado",
          url: "/certificados/participante",
          icon: "fa fa-book",
        };

        news.push(certificado);
      }

      if (this.perfil.is_admin_conferencia) {
        let tutorial = {
          name: "Gerenciar Tutoriais",
          url: "/tutoriais",
          icon: "fa fa-cog",
        };

        news.push(tutorial);
      }
      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let tutorial = {
          name: "Tutorial",
          url: "/tutorial",
          icon: "fa fa-caret-square-o-right",
        };

        news.push(tutorial);
      }

      if (this.perfil.is_admin_conferencia) {
        let chat = {
          name: "Gerenciar Chats",
          url: "/salachat",
          icon: "fa fa-comments",
        };

        news.push(chat);
      }

      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let chat = {
          name: "Chats",
          url: "/salachat",
          icon: "fa fa-comments",
        };

        news.push(chat);
      }

      if (this.perfil.is_admin_conferencia) {
        let mocao = {
          name: "Gerenciar Moções",
          url: "/mocao",
          icon: "fa fa-book",
        };

        news.push(mocao);
      }

      if (!this.perfil.is_admin_conferencia && !this.perfil.is_admin_local) {
        let mocao = {
          name: "Moções",
          url: "/mocao",
          icon: "fa fa-book",
        };

        news.push(mocao);
      }

      return news;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    home() {
      this.$router.push({ path: "/autenticada" });
    },
    can(permissao) {
      return this.$store.getters.validaPermissao(permissao);
    },
  },
};
</script>

<style lang="scss" scoped>
// CoreUI Icons Set
@import "@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "../../assets/scss/style";
</style>
<style scoped>
@media (max-width: 991px) {
  .conferencia-perfil {
    font-size: 95%;
  }
}

@media (max-width: 768px) {
  .conferencia-perfil {
    font-size: 75%;
  }
}
</style>


// WEBPACK FOOTER //
// src/templates/site-interno/SiteTemplate.vue